import styled from 'styled-components';
import { getStateColor } from "../../utils/getStateColor";
export const Container = styled.div`
  align-items: center;
  background-color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.secondary;
}};
  border-radius: 10px;
  cursor: ${_ref2 => {
  let {
    disabled
  } = _ref2;
  return disabled ? 'not-allowed' : 'pointer';
}};
  display: flex;
  gap: ${_ref3 => {
  let {
    size
  } = _ref3;
  return size === 'sm' ? '8px' : '12px';
}};
  height: ${_ref4 => {
  let {
    size
  } = _ref4;
  return size === 'sm' ? '48px' : size === 'md' ? '76px' : '96px';
}};
  opacity: ${_ref5 => {
  let {
    disabled
  } = _ref5;
  return disabled ? 0.5 : 1;
}};
  padding: ${_ref6 => {
  let {
    size
  } = _ref6;
  return size === 'sm' || size === 'md' ? '0 16px' : '0 32px';
}};
  width: '100%';

  &:hover {
    background-color: ${_ref7 => {
  let {
    theme,
    disabled
  } = _ref7;
  return !disabled && getStateColor(theme.colors.secondary, 'hover');
}};
  }

  &:active {
    background-color: ${_ref8 => {
  let {
    theme,
    disabled
  } = _ref8;
  return !disabled && getStateColor(theme.colors.secondary, 'pressed');
}};
  }

  &:focus {
    outline: ${_ref9 => {
  let {
    disabled
  } = _ref9;
  return disabled && 'none';
}};
  }
`;
export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  justify-content: center;
  max-width: 70%;
`;
export const IconContainer = styled.div`
  align-items: center;
  display: flex;
  height: ${_ref10 => {
  let {
    size
  } = _ref10;
  return size === 'sm' ? '20px' : size === 'md' ? '24px' : '36px';
}};
  justify-content: center;
  width: ${_ref11 => {
  let {
    size
  } = _ref11;
  return size === 'sm' ? '20px' : size === 'md' ? '24px' : '36px';
}};
`;
export const Decorator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Spinner = styled.div`
  animation-play-state: inherit;
  animation: 0.8s linear infinite spin;
  border-radius: 50%;
  border: solid ${_ref12 => {
  let {
    size
  } = _ref12;
  return size === 'sm' || size === 'md' ? '3px' : '4px';
}} transparent;
  border-bottom-color: ${_ref13 => {
  let {
    theme
  } = _ref13;
  return theme.colors.neutralL5;
}};
  border-left-color: ${_ref14 => {
  let {
    theme
  } = _ref14;
  return theme.colors.neutralL5;
}};
  min-height: ${_ref15 => {
  let {
    size
  } = _ref15;
  return size === 'sm' || size === 'md' ? '20px' : '36px';
}};
  min-width: ${_ref16 => {
  let {
    size
  } = _ref16;
  return size === 'sm' || size === 'md' ? '20px' : '36px';
}};
  will-change: transform;

  @keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`;
export const Title = styled.p`
  ${_ref17 => {
  let {
    theme,
    size
  } = _ref17;
  return size === 'sm' ? theme.fonts.infoMD : size === 'md' ? theme.fonts.titleXS : theme.fonts.titleMD;
}};
  color: ${_ref18 => {
  let {
    theme,
    titleStyle
  } = _ref18;
  return titleStyle === 'warning' ? theme.colors.yellowL0 : titleStyle === 'error' ? theme.colors.error : titleStyle === 'primary' ? theme.colors.primary : theme.colors.neutralL5;
}};
  margin: 0;
  padding: 0;
`;
export const Description = styled.p`
  ${_ref19 => {
  let {
    theme,
    size
  } = _ref19;
  return size === 'sm' ? theme.fonts.infoXS : size === 'md' ? theme.fonts.infoSM : theme.fonts.infoMD;
}};
  color: ${_ref20 => {
  let {
    theme
  } = _ref20;
  return theme.colors.neutralL5;
}};
  margin: 0;
  padding: 0;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const RightContainer = styled.div`
  align-items: center;
  display: flex;
  gap: ${_ref21 => {
  let {
    size
  } = _ref21;
  return size === 'sm' ? '4px' : '8px';
}};
  margin-left: auto;
`;
export const Notification = styled.div`
  ${_ref22 => {
  let {
    theme
  } = _ref22;
  return theme.fonts.labelSM;
}}
  background-color: ${_ref23 => {
  let {
    theme
  } = _ref23;
  return theme.colors.notification;
}};
  border-radius: 10px;
  color: ${_ref24 => {
  let {
    theme
  } = _ref24;
  return theme.colors.neutralL4;
}};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  user-select: none;
  width: 28px;
`;